<div class="assign-to-modal">
    <Modal
        id="assign-to-modal-id"
        bind:enabled={enabled}
        {cancelText}
        {confirmText}
        scrollBody={true}
        {titleText}
        on:confirm={handleConfirm}
        on:cancel={handleCancel}
    >
        <div slot="banner">
            <AssignToModalBanner />
        </div>
        <div slot="body">
            <AssignToModalTabs {isFirstLoad} {participants} {groups}/>
        </div>
    </Modal>
</div>

<script>
    import Modal from "@itslearning/prometheus/assets/modals/Modal/v2/Modal.svelte";
    import i18n from "@its-ui/planner-common/i18n";
    import AssignToModalBanner from "./AssignToModalBanner.svelte";
    import AssignToModalTabs from "./Tabs/AssignToModalTabs.svelte";
    import { assignPlan, getPlan } from "../../../api";
    import config from "../../../config";
    import { createEventDispatcher } from 'svelte';

    export let cancelText = i18n.cancel;
    export let confirmText = i18n.saveParticipants;
    export let enabled = false;
    export let isFirstLoad = false;
    export let titleText = i18n.assignTo;

    export let participants;
    export let groups;

    const dispatch = createEventDispatcher();

    const handleConfirm = async () => {
        const participantIds = participants.entityArray.filter((item) => item.isAssigned).map((item) => item.personId);
        const groupIds = groups.entityArray.filter((item) => item.isAssigned).map((item) => item.groupId);

        await assignPlan(config.planId, participantIds, groupIds);
        const updatedPlan = await getPlan(config.planId);
        const updatedElements = updatedPlan.elements;

        dispatch('assignToModalConfirmed', { updatedElements });
    };

    const handleCancel = () => {
        dispatch('assignToModalCancelled');
    };
</script>
